module.exports = __webpack_public_path__ + "img/ExitusUX_Prints.3cc149c7.png";